import { useMediaQuery, useTheme, Box, Card, Typography, darken } from '@mui/material';
import React from 'react';
import BeenhereIcon from '@mui/icons-material/Beenhere';

interface PromoteCompanyToggleCardProps {
	isPromoted: boolean;
}

// TODO: temporarily disabled
export const PromoteCompanyToggleCard = ({ isPromoted }: PromoteCompanyToggleCardProps) => {
	const isSmUp = useMediaQuery(useTheme().breakpoints.up('sm'));
	const theme = useTheme();
	return (
		<Card 
			elevation={0}
			color={isPromoted ? 'success' : 'primary'}
			sx={{ 
				minWidth: isSmUp ? '350px' : '300px',
				maxWidth: '350px',
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				// cursor: 'pointer',
				userSelect: 'none',
				...(isPromoted ? {
					backgroundColor: 'success.light',
					'&:hover': {
						bgcolor: darken(theme.palette.success.light, 0.1),
					},
				} : {
					// '&:hover': {
					// 	bgcolor: 'action.hover',
					// },
				}),
			// backgroundColor: 'background.paper',
			}} 
			// onClick={isPromoted ? onDelete : onCreate}
		>
			<Box sx={{ 
				display: 'flex', 
				flexDirection: 'column',
				alignItems: 'center',
				gap: 2,
				p: 4,
			}}>
				<BeenhereIcon sx={{ 
					fontSize: 48, 
					// color: isPromoted ? 'success.contrastText' : 'success.main' 
					color: 'action.disabled'
				}}
				/>
				<Typography 
					variant="h6" 
					// color={isPromoted ? 'success.contrastText' : 'primary'}
					color='action.disabled'
				>
					I accept quotes
				</Typography>
				<Typography 
					variant="body2" 
					// color={isPromoted ? 'success.contrastText' : 'text.secondary'}
					color='action.disabled'
					align="center">
					Let customers know that you can help them with this project.
				</Typography>
			</Box>
		</Card>
	);
};
